import React from 'react';
const IframePlayer = ({ url, dimensions }) => {
    const src = url;
    const commonProps = {
        'data-hook': 'video-iframe-placeholder',
        className: 'gallery-item-content video-iframe-placeholder',
        title: 'pro-gallery-video',
        style: dimensions,
        allow: 'fullscreen',
        allowFullScreen: true,
        loading: 'lazy',
    };
    if ((url === null || url === void 0 ? void 0 : url.includes('youtube.com')) || (url === null || url === void 0 ? void 0 : url.includes('youtu.be')) || (url === null || url === void 0 ? void 0 : url.includes('vimeo.com'))) {
        return React.createElement("iframe", Object.assign({}, commonProps, { src: url + '&autoplay=0&muted=1' }));
    }
    else {
        return (React.createElement("iframe", Object.assign({}, commonProps, { src: src, srcDoc: `
      <video controls preload='metadata'>
      <source src='${src}' type='video/mp4'>
    </video>
    ` })));
    }
};
export default IframePlayer;
//# sourceMappingURL=IframeVideoPlayer.js.map